import React from "react";
import { Link } from "react-router-dom";
import BtnLogOut from "./login/LogOut";

const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <img src="https://user-images.githubusercontent.com/89402461/157092542-2f7a1b19-2c82-4c60-9b89-655af2ca0366.png" width="50" height="50" alt="Logo Ey" />
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse flex-row-reverse" id="navbarNav">
            <ul className="navbar-nav  d-flex flex-colum-reverse">
              <li className="nav-item">
                <Link to="/" className="text-white p-2"> Home </Link>
              </li>
              <hr />
              <li className="nav-item">
                <Link to="/Poliza" className="text-white p-2"> Póliza </Link>
              </li>
              <hr />
              <li className="nav-item">
                <Link to="/Login" className="text-white p-2"> Inicia tu sesión </Link>
              </li>
              <hr />
              <li className="nav-item">
                <Link to="/EntrySinister" className="text-white p-2"> Ingresa tu siniestro </Link>
              </li>
              <hr/>
              <li className="nav-item">
                <Link to="/RecordHistory" className="text-white p-2"> Historial de siniestros </Link>
              </li>
              <hr/>
              <li className="nav-item">
                {/* <Link to="" className="text-white p-2"> Cerrar Sesión </Link> */}
                <BtnLogOut/>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;


